export default {
  appointmentContainer: {
    title: 'Dommages immobiliers',
    solution: 'Solution :',
    text: 'Choisir un professionnel agréé Allianz',
    text2: 'Date souhaitée pour les travaux',
    text3: 'Heure de passage souhaitée:',
    text4: "Vous avez indiqué ne pas connaître l'origine de votre sinistre.",
    text5: 'Choisissez une date et une heure ci-dessous pour organiser une recherche de fuite avec un spécialiste.',
    infoBox: 'Si les créneaux sont indisponibles ou incompatibles avec vos disponibilités, choisissez d\'être rappelé(e) pour fixer le rendez-vous sous 48h*.',
    workHour: '*Heures ouvrées et sauf problème exceptionnel indépendant de notre volonté',
    actions: {
      primary: 'Valider heure',
      secondaryHelpText: 'Aucun de ces créneaux ne vous convient?',
      secondary: 'Être rappelé(e) pour fixer un RDV',
      ren: {
        primary: 'Valider le créneau',
        tertiary: 'Choisir une autre solution'
      },
      wld: {
        primary: 'Valider le créneau',
        secondary: 'Je souhaite être rappelé(e) pour fixer un RDV'
      }
    },
    wld: {
      title: 'Prendre rendez-vous avec le plombier',
      text: 'Choisissez le créneau qui vous convient pour qu’un plombier vienne localiser la fuite.',
      infoText: 'Si les créneaux sont indisponibles ou incompatibles avec vos disponibilités, choisissez d\'être rappelé(e) pour fixer le rendez-vous.',
      confirmationModalRDV: {
        title: 'Votre demande de rendez-vous est bien enregistrée',
        body: 'À présent, décrivez-nous vos dommages afin que nous puissions prendre en charge votre sinistre dans les meilleurs conditions.',
        cta: 'Suivant'
      },
      confirmationModalRap: {
        title: 'Votre demande de rappel est bien enregistrée',
        body: 'À présent, décrivez-nous vos dommages afin que nous puissions prendre en charge votre sinistre dans les meilleurs conditions.',
        cta: 'Suivant'
      }
    },
    dates: {
      months: {
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre'
      }
    },
    notifications: {
      errors: {
        getSchedule:
          'Erreur! Il n’a pas été possible de récupérer les jours disponibles pour prendre rendez-vous.',
        postAppointment:
          'Erreur! Le rendez-vous sélectionné n’a pas pu être planifié.',
        postContact: 'Erreur! Le contact n’a pas pu être demandé.'
      }
    }
  }
}
